export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7782.f75ba0db.jpg";